import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { $a } from 'shared-base';
import { ContentProjects } from './ContentProjects';

export type ContentProjectsContainerProps = {};

export function ContentProjectsContainer(_props: ContentProjectsContainerProps) {
  const dispatch = useDispatch();
  const projects = useSelector(selectors.tables.$projects);
  const isLoading = useSelector(selectors.raw.$rawAppState).isLoading;

  const callbacks = useMemo(
    () => ({
      onAction: (action: Action) => {
        dispatch(action);
      },
      onCta: () => {
        dispatch($a('PROJECTS', 'new'));
      },
    }),
    []
  );

  return <ContentProjects projects={projects} isLoading={isLoading} callbacks={callbacks} />;
}

export default ContentProjectsContainer;
